{
  "blocks": [
    {
      "id": "proc-laparoscopy",
      "kind": "procedure",
      "tags": ["her", "testing", "endo", "pre-cycle"],
      "title": "Laparoscopy",
      "subtitle": "Minimally invasive surgery to evaluate and treat pelvic conditions",
      "body": {
        "procedureName": "Laparoscopy",
        "category": "diagnostic",
        "description": "A minimally invasive surgical procedure where a small camera is inserted through a tiny incision near the navel to examine the pelvic organs. It is the gold standard for diagnosing endometriosis and can treat adhesions, endometriomas, and other pelvic pathology at the same time.",
        "howItWorks": "Under general anesthesia, small incisions (5-10 mm) are made, typically one at the navel and 1-2 in the lower abdomen. CO2 gas inflates the abdomen for visibility. A camera and surgical instruments are inserted through the ports. The surgeon can see the uterus, ovaries, tubes, and pelvic surfaces. Endometriosis can be excised, adhesions lysed, cysts removed, and tubal patency assessed with dye.",
        "duration": "30 minutes to 2 hours depending on findings and treatment",
        "costRange": {
          "low": 5000,
          "high": 20000
        },
        "currency": "USD",
        "anesthesia": "general",
        "painAndComfort": [
          "You will be asleep during the procedure; abdominal soreness and shoulder discomfort from the gas are common afterward."
        ],
        "recoveryTime": "1-3 days off work (diagnostic); 1-2 weeks for operative cases",
        "whatToExpect": [
          "Performed in a hospital or ambulatory surgery center",
          "General anesthesia, you'll be fully asleep",
          "2-4 small incisions covered with steri-strips or skin glue",
          "Shoulder pain from residual CO2 gas (resolves in 1-3 days)",
          "Moderate abdominal soreness for several days",
          "Surgical photos and findings reviewed at post-op visit",
          "Fertility treatment may begin 1-3 months after recovery"
        ],
        "prepInstructions": [
          "Pre-operative blood work and anesthesia clearance",
          "No food or drink after midnight",
          "Arrange for someone to drive you home and stay with you for 24 hours",
          "Wear comfortable loose-fitting clothing",
          "Plan for 2-7 days off work depending on expected complexity"
        ],
        "risks": [
          "Mild abdominal and shoulder discomfort (common)",
          "Incision site bruising or infection (uncommon)",
          "Damage to surrounding organs (rare)",
          "Blood clot or excessive bleeding (rare)",
          "Potential ovarian reserve impact if endometriomas are excised (discuss with surgeon)"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Cœlioscopie",
          "description": "Geste chirurgical mini-invasif consistant à introduire une petite caméra par une incision au niveau du nombril pour explorer les organes pelviens. C'est l'examen de référence pour le diagnostic de l'endométriose, qui permet aussi de traiter dans le même temps adhérences, endométriomes et autres pathologies pelviennes.",
          "howItWorks": "Sous anesthésie générale, de petites incisions (5–10 mm) sont réalisées, généralement une au nombril et 1 à 2 dans le bas de l'abdomen. Du CO2 distend l'abdomen pour améliorer la visibilité. Une caméra et des instruments chirurgicaux sont introduits par les trocarts. Le chirurgien peut visualiser l'utérus, les ovaires, les trompes et les surfaces pelviennes. L'endométriose peut être excisée, les adhérences libérées, les kystes retirés, et la perméabilité tubaire évaluée au colorant.",
          "duration": "30 minutes à 2 heures selon les constatations et le traitement",
          "recoveryTime": "1 à 3 jours d'arrêt de travail (diagnostique) ; 1 à 2 semaines pour les gestes opératoires",
          "whatToExpect": [
            "Réalisée à l'hôpital ou en chirurgie ambulatoire",
            "Anesthésie générale ; vous êtes complètement endormie",
            "2 à 4 petites incisions recouvertes de Steri-Strips ou de colle cutanée",
            "Douleur scapulaire liée au CO2 résiduel (disparaît en 1 à 3 jours)",
            "Sensibilité abdominale modérée pendant plusieurs jours",
            "Photos opératoires et constatations discutées lors du rendez-vous post-opératoire",
            "Le traitement de fertilité peut reprendre 1 à 3 mois après la récupération"
          ],
          "prepInstructions": [
            "Bilan préopératoire et consultation d'anesthésie",
            "À jeun à partir de minuit (ni nourriture, ni boisson)",
            "Prévoyez quelqu'un pour vous raccompagner et rester avec vous 24 heures",
            "Portez des vêtements amples et confortables",
            "Prévoyez 2 à 7 jours d'arrêt selon la complexité prévue"
          ],
          "risks": [
            "Inconfort abdominal et scapulaire léger (fréquent)",
            "Hématome ou infection au point d'incision (peu fréquent)",
            "Lésion des organes voisins (rare)",
            "Caillot ou saignement important (rare)",
            "Impact possible sur la réserve ovarienne si des endométriomes sont retirés (à discuter avec le chirurgien)"
          ]
        }
      },
      "sources": [
        {
          "title": "ESHRE guideline: endometriosis",
          "authors": "ESHRE Endometriosis Guideline Development Group (Becker CM et al.)",
          "journal": "Human Reproduction Open",
          "year": 2022,
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8951218/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
